/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import AddAction from './AddAction/index'
import DraggableList from 'DesignSystem/DraggableList/index'
import EventAction from './EventAction/index'
import React from 'react'
import useListItemDataOnChange from './useListItemDataOnChange.js'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  onDragEnd,
  useListItemDataOnChange,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content"
  
}) {
let globalFeatureFlagsIsAutomationHubCommsEnabledValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'feature_flags.is_automation_hub_comms_enabled',
})
let automationActionsValueData = fromData.useDataValue({ viewPath,
context: 'automation',
path: 'actions',
})
let globalFeatureFlagsIsAutomationHubCommsEnabledValueData1 = fromData.useDataValue({ viewPath,
context: 'global',
path: 'feature_flags.is_automation_hub_comms_enabled',
})
let automationActionsValueData1 = fromData.useDataValue({ viewPath,
context: 'automation',
path: 'actions',
})
  return (<React.Fragment
>
<fromFlow.When is={globalFeatureFlagsIsAutomationHubCommsEnabledValueData}>
<DraggableList
  viewPath={`${viewPath}/DraggableList`}
 data="global.feature_flags.is_automation_hub_comms_enabled"
 data="automation.actions"
 from={automationActionsValueData}
 itemDataContextName="event_action"
 childName="EventAction"
 onDragEnd={onDragEnd}
 useListItemDataOnChange={useListItemDataOnChange}
>
{childProps => (
<EventAction
{...childProps}
  viewPath={`${viewPath}/EventAction`}
/>
)}
</DraggableList>
</fromFlow.When>
<fromFlow.When is={!globalFeatureFlagsIsAutomationHubCommsEnabledValueData1}>
<div
  data-testid="Content.List"
  data-view-path={viewPath}
 className="views-block"
>
{Array.isArray(automationActionsValueData1) && automationActionsValueData1.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="event_action"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/EventAction(${item?.id ?? item?._id ?? index})`}
      >
<EventAction
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/EventAction(${item?.id ?? item?._id ?? index})`}
/>
</ListItem>
)}
</div>
</fromFlow.When>
<AddAction
  viewPath={`${viewPath}/AddAction`}
/>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    let onChange = useListItemDataOnChange({ ...props, viewPath: props.parentViewPath })
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      onChange={onChange}
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }